export const defaultSelectedDate = () => {
    var fecha = new Date();
    fecha.setDate(fecha.getDate());
    return fecha;
};

export default {
    ag_grid: {
        selectedTheme: 'ag-theme-balham'
    },
    params: {
        date_from: defaultSelectedDate(),
        date_up: defaultSelectedDate(),
    },
    pharex_report: [],
    loading: {
        module: false
    }
};



// WEBPACK FOOTER //
// ./src/modules/report-pharex/state.js